import { render, staticRenderFns } from "./pdf_sales_temp1.vue?vue&type=template&id=b2504f22&"
import script from "./pdf_sales_temp1.vue?vue&type=script&lang=js&"
export * from "./pdf_sales_temp1.vue?vue&type=script&lang=js&"
import style0 from "./pdf_sales_temp1.vue?vue&type=style&index=0&id=b2504f22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports